import { Core } from "@faire/design-tokens";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { File } from "@faire/web--source/slate/icons/foundation/File";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled from "styled-components";

interface IProps {
  file: File;
  onRemove: () => void;
}

export const UploadedFile: React.FC<IProps> = ({ file, onRemove }: IProps) => {
  return (
    <Wrapper>
      <Box>
        <File color="inherit" fontSize="18px" />
        <Typography>{file.name}</Typography>
      </Box>
      <IconButton onClick={onRemove}>
        <Close color="inherit" fontSize="21px" />
      </IconButton>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Box = styled.div`
  padding: 18px;
  display: flex;
  gap: 10px;
  border: 1px solid ${Core.border.muted};
  flex: 1;
`;

const IconButton = styled.button`
  border: none;
  box-shadow: none;
  padding: 0;
  margin: 0;
  background: transparent;
  cursor: pointer;
`;
